import React from 'react';
import MaterialCheckbox from '@mui/material/Checkbox';

import TickIcon from '../../images/IconTick.svg';

const CheckboxChecked = () => (
  <div
    style={{
      padding: '4px',
      backgroundColor: '#FECB04',
      height: '20px',
      width: '20px',
      borderRadius: '2px',
      border: '1px solid #656565',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <img src={TickIcon} alt="tick" />
  </div>
);

const CheckBoxUnchecked = () => (
  <div
    style={{
      padding: '4px',
      border: '1px solid #656565',
      height: '20px',
      width: '20px',
      borderRadius: '2px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  ></div>
);

const Checkbox = ({ value, onChange, id, checked }) => {
  return (
    <MaterialCheckbox
      disableRipple
      icon={<CheckBoxUnchecked />}
      checkedIcon={<CheckboxChecked />}
      sx={{
        padding: '0px',
      }}
      value={value}
      onChange={onChange}
      id={id}
      checked={checked}
    />
  );
};

export default Checkbox;
